





































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import SessionModule from '~/store/session';
import InformationModal from '~/components/site/informationModal.vue';

@Component<Header>({
    components: {
        InformationModal,
    },
    icons: {
        faInfoCircle,
    },
})
export default class Header extends Vue {
    @Resolve
    session!: SessionModule;

    isShowInformationDialogue = false;

    toggleInfoDialogue() {
        this.isShowInformationDialogue = !this.isShowInformationDialogue;
    }

    handleHomeClick() {
        this.session.isAuthenticatedUser ? this.$router.push({ path: '/dashboard' }) : this.$router.push({ path: '/' });
    }
}
